var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:(_vm.style)},[_c('HollowDotsSpinner',{attrs:{"animation-duration":1000,"dot-size":12,"dots-num":3,"color":'#95a5a6'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }